// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLocalStorage from 'vue-localstorage';
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
import Promise from 'promise-polyfill';
import App from './App';
import router from './router';

// require('jspolyfill-array.prototype.find');
require('core-js');

Vue.use(VueLocalStorage, {
  bind: true,
});
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

if (!window.Promise) {
  window.Promise = Promise;
}

/*
Raven
  .config('https://556998727fa74de8b9dea2f5c8f46569@sentry.io/147722')
  .addPlugin(RavenVue, Vue)
  .install();
  */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  localStorage: {
    buylistProducts: {
      type: Array,
      default: [],
    },
    shopifyCheckoutId: {
      type: String,
      default: null,
    },
  },
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js